import { render, staticRenderFns } from "./Getraenkekartenew.vue?vue&type=template&id=387f34e4&scoped=true"
import script from "./Getraenkekartenew.vue?vue&type=script&lang=js"
export * from "./Getraenkekartenew.vue?vue&type=script&lang=js"
import style0 from "./Getraenkekartenew.vue?vue&type=style&index=0&id=387f34e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f34e4",
  null
  
)

export default component.exports